<template>
  <div class = "page1">

    <header class="bar bar-nav">
      <!--<div class="button button-link button-nav pull-left">-->
        <!--<span class="icon icon-left" @click="goBack"></span>-->
      <!--</div>-->
      <h1 class='title'>
        <div v-if="search.promotionGuid" style="color: #c82829">
          促销查询结果</div><div v-else>查询结果</div></h1>
    </header>

    <div class="bar bar-header-secondary">
      <div class="searchbar">
        <a class="searchbar-cancel" @click="goBack()">取消</a>
        <div class="search-input">
          <label class="icon icon-search" for="searchGoods"></label>
          <input type="search" id="searchGoods" placeholder='查询基因/病毒/功能...'
                 class="open-popup open-goods" data-popup=".popup-goods" readonly unselectable="on"/>
        </div>
      </div>
    </div>

    <!--<div class="searchTr" style="margin-top: 15%" >-->
    <!--<div v-for="tag in tags" class="searchBox default">{{tag.tagLabel}}</div>-->
    <!--</div>-->

    <!--<div class="searchTr" style="margin-top: 20%">-->
      <!--<div style="text-align: center">-->
        <!--<div class="searchBox default">细胞</div>-->
        <!--<div class="searchBox default">工具类腺病毒</div>-->
        <!--<div class="searchBox default">工具类AAV</div>-->
        <!--<div class="searchBox default">试剂盒</div>-->
      <!--</div>-->

      <!--<div style="text-align: center">-->
        <!--<div class="searchBox default">基因工具</div>-->
        <!--<div class="searchBox default">文库</div>-->
        <!--<div class="searchBox default">上调</div>-->
        <!--<div class="searchBox default">下调</div>-->
      <!--</div>-->

    <!--</div>-->


    <div id="products" class="content infinite-scroll-top" data-distance="5" style="margin-top: 1%;">
      <div v-if="num === 0 && allQueryData.length == 0"> 
        <a style="float: left;;margin-bottom: 20px; margin-left: 0.75rem;color: black">没有任何搜索结果!</a> 
        <a style="margin-left: 0.75rem;margin-right: 0.45rem" @click="toCust " v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 1">去定制!</a>
        <router-link class="item-link item-content" :to="{ name: 'myMessage'}"  style="margin-left: 0.75rem;margin-right: 0.45rem"  v-else>请找客服!</router-link> </div>
      <div v-if="num === 1 && allQueryData.length == 0">
        <div style="float: left;;margin-bottom: 20px; margin-left: 0.75rem;">正在查询中</div>
        <div style="color: #0a8ddf;margin-bottom: 20px; margin-right: 0.75rem" v-if="showBarForKit"><a class="pull-right open-panel" data-panel='#panel-right-demo'>筛选</a></div>
      </div>
      <div v-if="num !== 0 && allQueryData.length !== 0">
        <div class="list-block bar-div">
          <ul>
            <li class="item-content">
              <div class="item-inner">
                <div class="item-title">为您找到<span style="color: #0a8ddf;">{{total}}</span>条结果</div>
                <div class="item-after" style="color: #0a8ddf;" v-if="showBarForKit"><a class="pull-right open-panel" data-panel='#panel-right-demo'>筛选</a></div>
              </div>
            </li>
          </ul>
        </div>
        <merchdata :merchList="allQueryData" :showBarForKit="showBarForKit" :isFromSearch="true"></merchdata>
        <div class="button" id="button"  @click="loadmore" v-if="allQueryData.length < total">更多...</div>
        <div  v-if="allQueryData.length <= total && sessionInfo.customerInfo && sessionInfo.customerInfo.onBehalfOfCustomer === 1"  class="button"  @click="toCust "style="text-align: center;background-color: white;padding-bottom: 2rem">我要定制</div>
      </div>
      <!--<div>-->
        <!--<merchdata :merchList="recommendGoods" :description="description"></merchdata></div>-->
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import merchdata from '../finder/components/NewMerchandiseListA'
  import {mapState, mapMutations} from 'vuex'
  import Emkt from '../../emkt'
  export default {
    data () {
      return {
        recommendGoods: this.emkt.getLocalStorage('EmktAllRecommends'),
        allQueryData: [],
        description: '为你推荐',
        search: {},
        total: 0,
        categoryId: this.emkt.getLocalStorage('EmktCategoryID'),
        categoryIdToCount: {},
        num: 1
      }
    },
    created: function () {
      if (this.categoryId === '-1') {
        this.categoryId = undefined
      }
    },
    components: {
      merchdata
    },
    watch: {
      '$route': 'showQueryContent',
      'merchandiseQueryParams': function () {
        let _this = this
        let params = this.merchandiseQueryParams
        if (Emkt.getLocalStorage('panelFilterFlag')) {
          this.gcapi('queryMerchandise', params).then((res) => {
            if (res.body.code === 0) {
              _this.allQueryData = res.body.result.merchandiseList
              _this.total = res.body.result.total
              _this.categoryIdToCount = res.body.result.categoryIdToCount
              let data = {}
              data['total'] = this.total
              data['category'] = res.body.result.categoryIdToCount
              this.QUERY_TOTAL(data)
            }
          })
        }
      }
    },
    computed: {
      ...mapState([
        'merchandiseQueryParams', 'routerSrc', 'queryTotal', 'sessionInfo'
      ]),
      showBarForKit () {
        // 支原体暂不显示筛选bar
        let flag = true
        console.log(this.categoryId)
        if (this.categoryIdToCount[7]) {
          flag = false
        }
        if (this.categoryId !== 9 && this.categoryId !== 5 && this.categoryId !== 8) {
          flag = false
        }
        return flag
      }
    },
    mounted () {
      this.showQueryContent()
//      var self = this
//      setTimeout(() => {
//        $(function () {
//          $('.page1 .searchTr .searchBox').click(function () {
//            $(this).toggleClass('selected')
//
//            self.selectedTags = []
//            let selectTags = $('.page1 .searchTr')[0].getElementsByClassName('selected')
//            for (let i = 0; i < selectTags.length; i++) {
//              self.selectedTags.push(selectTags[i].innerHTML)
//            }
//
//            self.searchResult()
//          })
//        })
//      }, 3500)
    },
    methods: {
      ...mapMutations([
        'QUERY_TOTAL'
      ]),
      goBack () {
        this.$router.go(-1)
      },
      searchResult () {
//        let tagNames = $('.page1 .searchTr')[0].getElementsByClassName('selected')
//        let tagIds = []
//        for (let i = 0; i < tagNames.length; i++) {
//          tagIds.push(this.emkt.getEmktMetaData().tagNamesMap[tagNames[i].innerHTML])
//        }

        let merchandiseQueryParam = {}
        merchandiseQueryParam.keywordChosen = $('#searchGoods').val()
        merchandiseQueryParam.tagIds = this.search.tagIds
        merchandiseQueryParam.fromIndex = 0
        merchandiseQueryParam.promotionGuid = this.search.promotionGuid
        if (this.categoryId) {
          merchandiseQueryParam.categoryId = this.categoryId
        }
        $.showPreloader('正在查询结果,请稍等')
        this.gcapi('queryMerchandise', merchandiseQueryParam).then((response) => {
          this.allQueryData = response.body.result.merchandiseList
          this.total = response.body.result.total
          this.categoryIdToCount = response.body.result.categoryIdToCount
          let data = {}
          data['total'] = this.total
          if (this.total === 0) {
            this.num = 0
          }
          data['category'] = response.body.result.categoryIdToCount
          this.QUERY_TOTAL(data)
        }).then($.hidePreloader())
      },
      showQueryContent () {
//        var names = []
        this.search = JSON.parse(this.$route.query.search)
        $('#searchGoods').val(this.search.data.word)
//        var tagIds = this.search.data.tagIds
//        for (let i = 0; i < tagIds.length; i++) {
//          names.push(this.emkt.getEmktMetaData().tagIdsMap[tagIds[i]])
//        }
//
//        var $box = $('.page1 .searchBox')
//        for (let i = 0; i < $box.length; i++) {
//          if (names.indexOf($box[i].innerHTML) >= 0) {
//            $($box[i]).addClass('selected')
//          }
//        }
        this.searchResult()
      },
      toCust () {
        this.$router.push({name: 'custOrder'})
      },
      loadmore () {
        var fromIndex = this.allQueryData.length
        if (fromIndex >= this.total) {
//          $('#button').remove()
//          $('#over').append('去定制')
          return
        } else {
          var addlist = []
          let merchandiseQueryParam = {}
          merchandiseQueryParam.keywordChosen = $('#searchGoods').val()
          merchandiseQueryParam.tagIds = this.search.tagIds
          merchandiseQueryParam.fromIndex = fromIndex
          merchandiseQueryParam.promotionGuid = this.search.promotionGuid
          merchandiseQueryParam.categoryId = this.categoryId
          this.gcapi('queryMerchandise', merchandiseQueryParam).then((response) => {
            addlist = response.body.result.merchandiseList
            for (var i = 0; i < addlist.length; i++) {
              this.allQueryData.push(addlist[i])
            }
            let data = {}
            data['total'] = this.total
            data['category'] = response.body.result.categoryIdToCount
            this.QUERY_TOTAL(data)
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .fade-enter-active {
    transition: all .2s ease;
  }
  .fade-leave-active {
    transition: all .8s;
  }
  .fade-enter, .fade-leave-to {
    transform: translate3d(10rem, 1rem, 0);
    opacity: 0;
  }
  .button{
    color: #0a8ddf;
    border: 0rem;
    font-size: 1rem;
    padding-bottom: 2rem;
    background-color: white
  }
  .bar-div{
    margin-top: 0rem;
    z-index: 10;
    position: fixed;
    width: 100%;
    height: 2.2rem;
  }
  .div-po{
    height: 2.2rem;
  }
</style>



// WEBPACK FOOTER //
// SearchDetails.vue?6269c680